document.addEventListener('click', (e) => {
  const openBtn = e.target.closest('[data-newsletter-open]');
  const closeBtn = e.target.closest('[id^="newsletter-panel-close--"]');
  const overlay = e.target.closest('.newsletter-overlay');

  if (openBtn) {
    const uid = openBtn.getAttribute('data-newsletter-open');
    const panel = document.getElementById(`newsletter-panel--${uid}`);
    const panelOverlay = document.getElementById(`newsletter-overlay--${uid}`) || document.getElementById('newsletter-overlay-global');

    if (!panel) return;
    
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (panelOverlay) panelOverlay.classList.add('open');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    return;
  }

  if (closeBtn) {
    const uid = closeBtn.id.replace('newsletter-panel-close--', '');
    const panel = document.getElementById(`newsletter-panel--${uid}`);
    const panelOverlay = document.getElementById(`newsletter-overlay--${uid}`) || document.getElementById('newsletter-overlay-global');
    const trigger = document.querySelector(`[data-newsletter-open="${uid}"]`);
    
    if (!panel) return;

    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (panelOverlay) panelOverlay.classList.remove('open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    return;
  }

  // Cerrar al hacer click en el overlay
  if (overlay && overlay.classList.contains('open')) {
    const uid = overlay.id.replace('newsletter-overlay--', '');
    const panel = document.getElementById(`newsletter-panel--${uid}`);
    const trigger = document.querySelector(`[data-newsletter-open="${uid}"]`);
    
    if (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const openPanel = document.querySelector('.newsletter-panel.is-open');
    if (openPanel) {
      const uid = openPanel.id.replace('newsletter-panel--', '');
      const panel = document.getElementById(`newsletter-panel--${uid}`);
      const panelOverlay = document.getElementById(`newsletter-overlay--${uid}`) || document.getElementById('newsletter-overlay-global');
      const trigger = document.querySelector(`[data-newsletter-open="${uid}"]`);
      
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        if (panelOverlay) panelOverlay.classList.remove('open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    }
  }
});